import { Link } from 'react-router-dom';
import Tab from './Tabs';
import { categories, ingredients } from '../../resource/Products';

function Body(props) {
  const { product } = props;
  const metas = (function () {
    let catArr = categories.filter((category) =>
      product.categories.includes(category.id)
    );
    catArr.map((cat) => (cat.section = 'category'));
    let ingArr = ingredients.filter((ingredient) =>
      product.ingredients.includes(ingredient.id)
    );
    ingArr.map((ing) => (ing.section = 'ingredient'));

    return catArr.concat(ingArr);
  })();

  const image = require(`../../assets/images/products/${product.img}`);
  return (
    <div className="detail__body-container">
      <div className="detail__body-wrapper row">
        <div className="detail__body-image">
          <img src={image.default} alt={product.name} />
        </div>
        <div className="detail__body-content">
          <div className="detail__content-container column">
            <div className="detail__content-title">
              <h1>{product.name}</h1>
            </div>
            <div className="detail__content-amount">
              <h3>({product.amount})</h3>
            </div>
            <div className="detail__content-price row">
              <h3>{product.price}</h3>
              {product.link && <LinkToBuy link={product.link} />}
            </div>
            <div className="detail__content-highlignt column">
              <div
                dangerouslySetInnerHTML={{ __html: product.highlight }}
              ></div>
            </div>
            <Tab
              description={product.description}
              ingredient={product.ingredient}
              dosage={product.dosage}
              warnings={product.warnings}
            />
          </div>
        </div>
      </div>
      <div className="detail__body-meta">
        <div className="detail__meta-container">
          <ul className="detail__meta-content row">
            {product.SKU && (
              <li className="detail__meta-item">
                <span>SKU: </span>
                <span>{product.SKU}</span>
              </li>
            )}
            <li className="detail__meta-item">
              <span>분류: </span>
              {metas.map((meta) => (
                <span key={meta.id}>
                  <Link to={`/products/${meta.section}/${meta.path}`}>
                    {meta.name}
                  </Link>
                  ,
                </span>
              ))}
            </li>
            {product.tags.length !== 0 && (
              <li className="detail__meta-item">
                <span>태그: </span>{' '}
                {product.tags.map((tag) => (
                  <span key={tag.id}>{tag}</span>
                ))}
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}

const LinkToBuy = ({ link }) => {
  return (
    <a
      className="detail__content-buy"
      href={link}
      target="_blank"
      rel="noreferrer"
    >
      <button>구매하기</button>
    </a>
  );
};

export default Body;
